import ColorPalette from "./palette.json";

export default (color, variation) => ColorPalette[color][variation].value;
